// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__20V5a","label":"LabeledBox_label__2lBMv"};